import { BASE_URLS } from "../../api/axios";

/* ---------- Safe path join helper ---------- */
const join = (base, path) =>
  `${String(base ?? "").replace(/\/$/, "")}${String(path ?? "")}`;

/* ===== AUTH ===== */
export const AUTH_PATHS = {
  LOGIN: "/auth/login",
  VERIFY_TOKEN: "/auth/verify",
  REQUEST_RESET: "/auth/password/request-reset",
  VERIFY_RESET_CODE: "/auth/password/verify-code",
  RESET_PASSWORD: "/auth/password/reset",
  VERIFY_2FA: "/auth/verify-2fa",
  LOGOUT: "/auth/logout",
  VERIFY_CODE: "/auth/verify-code",
  RESEND_2FA: "/auth/resend-2fa-code",
};

/* ===== OAuth URLs ===== */
export const OAUTH_URLS = {
  GOOGLE: join(BASE_URLS.GATEWAY, "/auth/google/login"),
  FACEBOOK: join(BASE_URLS.GATEWAY, "/auth/facebook/login"),
  GITHUB: join(BASE_URLS.GATEWAY, "/auth/github"),
};

/* ===== USERS ===== */
export const USERS_PATHS = {
  REGISTER: "/register",
  OAUTH_UPSERT: "/oauth/upsert",
  BASE: "/",
  BY_ID: (id) => `/${id}`,
  UPDATE: (id) => `/${id}`,
  DELETE: (id) => `/${id}`,
  ME: "/me",
  AVATAR_UPLOAD: (id) => `/${id}/avatar`,
  SEARCH: "/search",
  ALL: "/users",
};

/* ===== MEDICAL ===== */
export const MEDICAL_PATHS = {
  BASE: "/",
  CREATE: (userId) => `/${userId}`,
  BY_USER: (userId) => `/${userId}`,
  UPDATE: (userId) => `/${userId}`,
  DELETE: (userId) => `/${userId}`,

  BMI_HISTORY: (userId) => `/${userId}/bmi-history`,
  UPDATE_BMI_HISTORY: (userId, id) => `/${userId}/bmi-history/${id}`,

  PERSONAL_HISTORY: (userId) => `/${userId}/personal-history`,
  PERSONAL_HISTORY_TIMELINE: (userId) => `/${userId}/personal-history/history`,
  ADD_PERSONAL_HISTORY: (userId) => `/${userId}/personal-history`,
  UPDATE_PERSONAL_HISTORY: (userId, id) => `/${userId}/personal-history/${id}`,
  DELETE_PERSONAL_HISTORY: (userId, id) => `/${userId}/personal-history/${id}`,

  SURGICAL_HISTORY: (userId) => `/${userId}/surgical-history`,
  UPDATE_SURGICAL_HISTORY: (userId, id) => `/${userId}/surgical-history/${id}`,
  DELETE_SURGICAL_HISTORY: (userId, id) => `/${userId}/surgical-history/${id}`,

  FAMILY_HISTORY: (userId) => `/${userId}/family-history`,
  UPDATE_FAMILY_HISTORY: (userId, id) => `/${userId}/family-history/${id}`,
  DELETE_FAMILY_HISTORY: (userId, id) => `/${userId}/family-history/${id}`,

  ALLERGIES: (userId) => `/${userId}/allergies`,
  UPDATE_ALLERGY: (userId, id) => `/${userId}/allergies/${id}`,
  DELETE_ALLERGY: (userId, id) => `/${userId}/allergies/${id}`,

  VACCINATIONS: (userId) => `/${userId}/vaccinations`,
  UPDATE_VACCINATION: (userId, id) => `/${userId}/vaccinations/${id}`,
  DELETE_VACCINATION: (userId, id) => `/${userId}/vaccinations/${id}`,

  VITALS: (userId) => `/${userId}/vitals`,
  UPDATE_VITAL: (userId, id) => `/${userId}/vitals/${id}`,
  DELETE_VITAL: (userId, id) => `/${userId}/vitals/${id}`,

  BY_ID: (id) => `/record/${id}`,
  UPDATE_BY_ID: (id) => `/record/${id}`,
  DELETE_BY_ID: (id) => `/record/${id}`,

  INSURANCE_PROVIDERS: "/insurance-providers",
};

/* ===== CYCLES / CALENDAR ===== */
export const CYCLES_PATHS = {
  BASE: "/cycles",
  BY_USER: (userId) => `/cycles/${userId}`,
  PREDICTIONS: (userId) => `/cycles/${userId}/predictions`,
  FERTILITY_WINDOW: (userId) => `/cycles/${userId}/fertility-window`,
  SUMMARY: (userId) => `/cycles/${userId}/summary`,
};

/* ===== RELATIVES ===== */
export const RELATIVES_PATHS = {
  BASE: "/relatives",
  BY_USER: (userId) => `/relatives/${userId}`,
  BY_ID: (id) => `/relatives/${id}`,
  ACCEPT: (id) => `/relatives/accept/${id}`,
};

export const MESSAGES_PATHS = {
  BASE: "/messages",
  SEND: "/messages",
  LIST(userA, userB) {
    return `/messages?${new URLSearchParams({ userA, userB }).toString()}`;
  },
};

const ENDPOINTS = {
  AUTH: AUTH_PATHS,
  OAUTH: OAUTH_URLS,
  USERS: USERS_PATHS,
  MEDICAL: MEDICAL_PATHS,
  CYCLES: CYCLES_PATHS,
  RELATIVES: RELATIVES_PATHS,
  MESSAGES: MESSAGES_PATHS,
};

export default ENDPOINTS;
